import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { Divider, Grid, Typography } from '@material-ui/core';

import { useStyles } from './styles';

import * as session from '../../utils/session';
import { ACCESS_PORTAL_TEXT, LOGIN_ORIGIN } from '../../consts/text/form-login';
import { PortalAccessCards } from '../../containers/PortalAccessCards';
import { usePartner } from '../../context/PartnerContext';
import { generateUUID } from '../../library/authorization';
import { AutenticationActions } from '../../store/ducks/autentication';

/**
 * @Login Página de Login da aplicação
 * @CriadoEm 14/01/2022
 */
export default function LoginPage() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { isNotBB } = usePartner();

  useEffect(() => {
    const uuid = localStorage.getItem('UUID');

    if (!uuid) {
      localStorage.setItem('UUID', generateUUID());
    }

    (async () => {
      dispatch(AutenticationActions.getURLRequest());
    })();
  }, [dispatch]);

  useEffect(() => {
    session.clearUserName();
    session.clearUserNamePrimeiroAcesso();
    session.clearDataNascPrimeiroAcesso();
  }, []);

  useEffect(() => {
    const params = window?.location?.pathname.split('/');

    const origem = params[1];
    const hash = params[2];
    let chatbot = params[3];

    if (origem === LOGIN_ORIGIN.CHATBOT) {
      session.setChatbot(chatbot);
      session.setHashChatbot(hash);
    } else {
      chatbot = session.getChatbot();
    }
  }, []);

  return (
    <Grid container justifyContent="center">
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        className={classes.gridContainer}
      >
        <Grid container direction="column">
          <Typography className={classes.title}>
            {isNotBB
              ? ACCESS_PORTAL_TEXT.HOME_TITLE_WL
              : ACCESS_PORTAL_TEXT.HOME_TITLE}
          </Typography>
          <Divider className={classes.underlineText} />
        </Grid>
      </Grid>

      <PortalAccessCards />
    </Grid>
  );
}
